(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobx"), require("sbRespLib"), require("sbRespUI"), require("mobxReact"));
	else if(typeof define === 'function' && define.amd)
		define("sb-responsive-racing-sports-blocks", ["React", "mobx", "sbRespLib", "sbRespUI", "mobxReact"], factory);
	else if(typeof exports === 'object')
		exports["sb-responsive-racing-sports-blocks"] = factory(require("React"), require("mobx"), require("sbRespLib"), require("sbRespUI"), require("mobxReact"));
	else
		root["sb-responsive-racing-sports-blocks"] = factory(root["React"], root["mobx"], root["sbRespLib"], root["sbRespUI"], root["mobxReact"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 